import { Reveal, Overline } from "@/components/Reveal";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is Charles McKuhn Ministries a Pentecostal ministry?",
    a: "Yes. Charles McKuhn Ministries is an apostolic, Pentecostal ministry that believes in the baptism of the Holy Ghost with the evidence of speaking in other tongues, deliverance, divine healing, and prophecy.",
  },
  {
    q: "Who is Apostle Charles McKuhn?",
    a: "Charles A. McKuhn Jr. is an apostle, prophetic intercessor, author, and community leader who flows under the authority and unction of the Holy Ghost, carrying the mantle and spirit of Elijah.",
  },
  {
    q: "How can I invite Apostle McKuhn to minister at a revival or event?",
    a: "You can request a revival, book signing, or speaking engagement through the Contact section of this site, or by emailing charlesmckuhn99@gmail.com.",
  },
  {
    q: "How can I support or partner with the ministry?",
    a: "You can sow into the ministry through Cash App at $prophetmckuhn1 (Charles McKuhn Ministries), supporting revivals, youth mentorship, and community outreach.",
  },
];

export const FAQ = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="relative py-24 sm:py-32 bg-parchment dark:bg-ink"
  >
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Overline>Frequently Asked</Overline>
        <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
          Questions & answers.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-border">
              <AccordionTrigger className="font-serif text-lg sm:text-xl py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
